/**
 * AnswerEvent — renderiza tipo 'answer'
 * payload: { markdown, attachments?[], sources?[] }
 * R-PT-09: no almacena estado; rehidrata desde el chat store.
 */

import { useRef, useEffect } from 'react'

// Markdown mínimo sin dependencia externa (bold, italic, headers, code, links)
// La dependencia react-markdown se usará cuando se instalen los paquetes.
// Por ahora: renderizador inline ligero.
function SimpleMarkdown({ text }) {
  // Escapar HTML y aplicar reglas básicas
  const html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // Headers
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/^## (.+)$/gm, '<h2>$1</h2>')
    .replace(/^# (.+)$/gm, '<h1>$1</h1>')
    // Bold / italic
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    // Inline code
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    // Block quote
    .replace(/^&gt; (.+)$/gm, '<blockquote>$1</blockquote>')
    // Unordered list items
    .replace(/^[-*] (.+)$/gm, '<li>$1</li>')
    // Paragraphs (doble salto)
    .split(/\n\n+/)
    .map(block => {
      if (block.startsWith('<h') || block.startsWith('<blockquote') || block.startsWith('<li'))
        return block
      return `<p>${block.replace(/\n/g, '<br>')}</p>`
    })
    .join('\n')

  return (
    <div
      className="markdown-body"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

export default function AnswerEvent({ payload }) {
  const { markdown = '', sources = [] } = payload

  return (
    <div className="event-answer">
      <SimpleMarkdown text={markdown} />
      {sources.length > 0 && (
        <div className="event-answer__sources">
          <span className="event-answer__sources-label">Fuentes:</span>
          {sources.map((s, i) => (
            <span key={i} className="event-answer__source">{s.label}</span>
          ))}
        </div>
      )}
    </div>
  )
}
